document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('header');
  if (!header) return;

  const handleScroll = () => {
    const isMobile = window.innerWidth <= 768;

    if (!isMobile) {
      header.classList.remove('is-scrolled');
      return;
    }

    if (window.scrollY > 0) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);

  handleScroll(); // 初期実行
});

// ------------------------------------------------
// header ハンバーガメニュー
// ------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  const menuBtn = document.querySelector('.menu');
  const navMenu = document.querySelector('.navmn');
  const body = document.body;

  if (!menuBtn || !navMenu) return;

  menuBtn.addEventListener('click', function () {
    menuBtn.classList.toggle('is-open');
    navMenu.classList.toggle('is-open');
    body.classList.toggle('menu-open');
  });

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      navMenu.classList.add('is-scroll');
    } else {
      navMenu.classList.remove('is-scroll');
    }
  });
});

// ------------------------------------------------
// header SP用 アコーディオン
// ------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  const titles = document.querySelectorAll('.sp-ttl');

  titles.forEach(function (ttl) {
    ttl.addEventListener('click', function () {
      if (window.innerWidth > 768) return;

      ttl.classList.toggle('active');

      const acc = ttl.nextElementSibling;
      if (!acc || !acc.classList.contains('header__submenu')) return;

      toggleSlide(acc, 500);
    });
  });

  function toggleSlide(element, duration) {
    if (element.classList.contains('is-open')) {
      slideUp(element, duration);
    } else {
      slideDown(element, duration);
    }
  }

  function slideDown(element, duration) {
    element.classList.add('is-open');
    element.style.removeProperty('display');

    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;

    const height = element.scrollHeight;
    element.style.overflow = 'hidden';
    element.style.height = '0px';

    element.offsetHeight; // reflow

    element.style.transition = `height ${duration}ms`;
    element.style.height = height + 'px';

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }

  function slideUp(element, duration) {
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';

    element.offsetHeight; // reflow

    element.style.transition = `height ${duration}ms`;
    element.style.height = '0px';

    setTimeout(() => {
      element.classList.remove('is-open');
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }
});

// ------------------------------------------------
// footer SP用 アコーディオン
// ------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  const footerTitles = document.querySelectorAll('.footer-col .link-ttl');

  footerTitles.forEach(function (ttl) {
    ttl.addEventListener('click', function () {
      if (window.innerWidth > 768) return;

      const menu = ttl.nextElementSibling;
      if (!menu || !menu.classList.contains('footer-menu')) return;

      ttl.classList.toggle('active');
      toggleSlide(menu, 400);
    });
  });

  /* ===== 共通スライド処理 ===== */
  function toggleSlide(element, duration) {
    if (window.getComputedStyle(element).display === 'none') {
      slideDown(element, duration);
    } else {
      slideUp(element, duration);
    }
  }

  function slideDown(element, duration) {
    element.style.display = 'block';
    const height = element.scrollHeight + 'px';

    element.style.height = '0px';
    element.style.overflow = 'hidden';

    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height;

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      element.classList.add('is-open');
    }, duration);
  }

  function slideUp(element, duration) {
    const height = element.scrollHeight + 'px';

    element.style.height = height;
    element.style.overflow = 'hidden';

    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = '0px';

    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      element.classList.remove('is-open');
    }, duration);
  }

});

// ------------------------------------------------
// コレクション用 collection リンク処理
// ------------------------------------------------
function toggleCollectionFilterMenu(){
  const menu = document.querySelector('#collection-filter-menu');
  if(!menu) return;
  const path = window.location.pathname;
  const isAll = path === '/collections/all';
  const isSale = path === '/collections/sale';
  const params = new URLSearchParams(window.location.search);
  let hasFilter = false;
  params.forEach((v,k)=>{
    if(k.startsWith('filter.')){
      hasFilter = true;
    }
  });
  /* allコレクション */
  if(isAll && hasFilter){
    menu.classList.add('collection-filter-hidden');
  }else{
    menu.classList.remove('collection-filter-hidden');
  }
}
/* URL変化検知 */
let lastUrl = location.href;
function observeUrlChange(){
  const observer = new MutationObserver(()=>{
    if(location.href !== lastUrl){
      lastUrl = location.href;
      toggleCollectionFilterMenu();
    }

  });
  observer.observe(document,{
    subtree:true,
    childList:true
  });
}
document.addEventListener('DOMContentLoaded',()=>{
  toggleCollectionFilterMenu();
  observeUrlChange();
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".col-list-ttl").forEach(title => {
    title.addEventListener("click", () => {

      const content = title.nextElementSibling;
      title.classList.toggle("close");
      if (content) {
        content.classList.toggle("close");
      }
    });
  });
});

// ------------------------------------------------
// コレクション用 filter 関連（疑似選択ロック + sort_by自動付与除去 + sort_by末尾寄せ）
// ------------------------------------------------
(() => {
  /**
   * =========================
   * 1) コレクションhandle → 疑似選択(ロック)するfacet定義
   * =========================
   */
  const IMPLIED = {
    // --- メーカー固定コレクション例 ---
    "マキタmakita-1": [{ param: "filter.p.m.custom.maker", label: "マキタ" }],
    "ハイコーキhikoki": [{ param: "filter.p.m.custom.maker", label: "ハイコーキ" }],
    "パナソニック": [{ param: "filter.p.m.custom.maker", label: "パナソニック" }],
    "ボッシュbosch": [{ param: "filter.p.m.custom.maker", label: "ボッシュ" }],
    "マックスmax": [{ param: "filter.p.m.custom.maker", label: "マックス" }],
    "リョービryobi": [{ param: "filter.p.m.custom.maker", label: "リョービ" }],
    "泉精器izumi": [{ param: "filter.p.m.custom.maker", label: "泉精器" }],
    "オグラogura": [{ param: "filter.p.m.custom.maker", label: "オグラ" }],
    "スナップオンsnap-on": [{ param: "filter.p.m.custom.maker", label: "スナップオン" }],
    "タジマtajima": [{ param: "filter.p.m.custom.maker", label: "タジマ" }],
    "キトーkito": [{ param: "filter.p.m.custom.maker", label: "キトー" }],
    "極東産機kyokuto": [{ param: "filter.p.m.custom.maker", label: "極東産機" }],
    "レッキスrex": [{ param: "filter.p.m.custom.maker", label: "レッキス" }],
    "ヒルティhilti": [{ param: "filter.p.m.custom.maker", label: "ヒルティ" }],
    "ホンダhonda": [{ param: "filter.p.m.custom.maker", label: "ホンダ" }],
  };

  /**
   * =========================
   * 2) ユーティリティ
   * =========================
   */
  const SORT_SELECTOR = 'select[name="sort_by"], input[name="sort_by"]';

  const normalizeLabel = (s) =>
    (s || "")
      .trim()
      .replace(/\s+/g, " ")
      .replace(/（[^）]*）/g, "")
      .replace(/\([^)]*\)/g, "")
      .trim();

  const getHandleFromPath = () => {
    const path = window.location.pathname.replace(/\/+$/, "");
    const last = path.split("/").pop() || "";
    try {
      return decodeURIComponent(last);
    } catch {
      return last;
    }
  };

  const findAccordionByParam = (param) => {
    const dashed = param.replace(/\./g, "-");
    return document.querySelector(
      `accordion-custom[data-filter-param-name="${CSS.escape(dashed)}"]`
    );
  };

  const findTargetInput = (accordion, param, label) => {
    const inputs = accordion.querySelectorAll(
      `input[type="checkbox"][name="${CSS.escape(param)}"]`
    );
    const target = normalizeLabel(label);

    for (const input of inputs) {
      const id = input.getAttribute("id");
      const labelEl = id ? accordion.querySelector(`label[for="${CSS.escape(id)}"]`) : null;
      const t = normalizeLabel(input.dataset.label || labelEl?.textContent || input.value || "");
      if (t === target) return input;
    }
    return null;
  };

  /**
   * =========================
   * 3) 疑似選択ロック（再レンダ対応）
   * =========================
   */
  const unlockAll = () => {
    document.querySelectorAll('input[type="checkbox"][data-locked="1"]').forEach((input) => {
      input.disabled = false;
      input.removeAttribute("disabled");
      delete input.dataset.locked;
    });

    document
      .querySelectorAll("li.facets__inputs-list-item[data-hidden-by-lock='1']")
      .forEach((li) => {
        li.style.display = "";
        delete li.dataset.hiddenByLock;
      });

    document.querySelectorAll("[data-hidden-showmore='1']").forEach((el) => {
      el.style.display = "";
      delete el.dataset.hiddenShowmore;
    });

    document.querySelectorAll("[data-hidden-clear='1']").forEach((el) => {
      el.style.display = "";
      delete el.dataset.hiddenClear;
    });
  };

  const revealLi = (li) => {
    if (!li) return;
    li.classList.remove("hidden", "mobile:hidden");
    li.style.display = "";
  };

  const lockFacetValue = ({ param, label }) => {
    const accordion = findAccordionByParam(param);
    if (!accordion) return;

    const details = accordion.querySelector("details");
    if (details) details.open = true;

    const input = findTargetInput(accordion, param, label);
    if (!input) return;

    // 疑似選択
    input.checked = true;
    input.setAttribute("checked", "");

    // 外せないように固定
    input.disabled = true;
    input.setAttribute("disabled", "");
    input.dataset.locked = "1";

    // ★ ここが追加：対象が「もっと見る」の隠し側でも必ず表示
    const keepLi = input.closest("li.facets__inputs-list-item");
    revealLi(keepLi);

    // 他項目を非表示
    accordion.querySelectorAll("li.facets__inputs-list-item").forEach((li) => {
      if (li !== keepLi) {
        li.style.display = "none";
        li.dataset.hiddenByLock = "1";
      }
    });

    // show more / clear を非表示
    const showMore = accordion.querySelector(".show-more__button");
    if (showMore) {
      showMore.style.display = "none";
      showMore.dataset.hiddenShowmore = "1";
    }
    const clear = accordion.querySelector(".facets__clear, facet-clear-component");
    if (clear) {
      clear.style.display = "none";
      clear.dataset.hiddenClear = "1";
    }
  };

  const applyLocks = () => {
    const handle = getHandleFromPath();
    const rules = IMPLIED[handle];
    if (!rules || !rules.length) return;

    unlockAll();
    rules.forEach(lockFacetValue);
  };

  /**
   * =========================
   * 4) sort_by の扱い
   * =========================
   * - ユーザーが sort を「変更した」場合のみ sort_by を許可
   * - それ以外は、facets.js が勝手に付けても URL から削除する
   * - 許可する場合は URL の末尾に寄せる
   */
  let userTouchedSort = false;

  const bindSortTouch = () => {
    // 二重バインド防止
    if (document.documentElement.dataset.__sortTouchBound === "1") return;
    document.documentElement.dataset.__sortTouchBound = "1";

    document.addEventListener(
      "change",
      (e) => {
        const t = e.target;
        if (!t) return;
        if (t.matches && t.matches(SORT_SELECTOR)) {
          userTouchedSort = true;
          // sortを変えた直後に整形
          setTimeout(normalizeUrl, 0);
        }
      },
      true
    );
  };

  const normalizeUrl = () => {
    const url = new URL(window.location.href);
    const hasSort = url.searchParams.has("sort_by");

    if (hasSort && !userTouchedSort) {
      // ★ フィルター操作で勝手に付く sort_by を消す
      url.searchParams.delete("sort_by");
      const qs = url.searchParams.toString();
      const next = url.pathname + (qs ? `?${qs}` : "") + url.hash;
      history.replaceState({}, "", next);
      return;
    }

    if (hasSort && userTouchedSort) {
      // ★ sort_by は末尾へ
      const sort = url.searchParams.get("sort_by");
      url.searchParams.delete("sort_by");
      url.searchParams.append("sort_by", sort);

      const qs = url.searchParams.toString();
      history.replaceState({}, "", url.pathname + (qs ? `?${qs}` : "") + url.hash);
    }
  };

  /**
   * =========================
   * 5) facets.js 再レンダ追従
   * =========================
   */
  let rafPending = false;
  const scheduleReapply = () => {
    if (rafPending) return;
    rafPending = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        rafPending = false;
        applyLocks();
        normalizeUrl();
      });
    });
  };

  /**
   * history を hook して、URL更新のたびに normalize を確実に噛ませる
   */
  const hookHistory = () => {
    if (history.__reriseHooked) return;
    history.__reriseHooked = true;

    const _push = history.pushState;
    const _replace = history.replaceState;

    history.pushState = function (...args) {
      _push.apply(this, args);
      scheduleReapply();
    };
    history.replaceState = function (...args) {
      _replace.apply(this, args);
      scheduleReapply();
    };

    window.addEventListener("popstate", scheduleReapply);
  };

  const boot = () => {
    hookHistory();
    bindSortTouch();

    // 初回
    applyLocks();
    normalizeUrl();

    // facets.js の差し替え拾う
    const mo = new MutationObserver(scheduleReapply);
    mo.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener("DOMContentLoaded", boot);
})();


// ------------------------------------------------
// よくある質問 アコーディオン
// ------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const questions = document.querySelectorAll('.faq-question');

  questions.forEach(question => {
    const answer = question.nextElementSibling;

    // 初期状態（閉）
    answer.style.maxHeight = '0px';
    answer.style.overflow = 'hidden';
    answer.style.margin = '0';

    question.addEventListener('click', () => {
      const isOpen = question.classList.contains('is-open');

      // いったん全部閉じる
      questions.forEach(q => {
        q.classList.remove('is-open');
        const a = q.nextElementSibling;
        a.style.maxHeight = '0px';
        a.style.marginTop = '0';
      });

      // 開く
      if (!isOpen) {
        question.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.style.margin = '25px 0 0';
      }
    });
  });
});


// ------------------------------------------------
// 商品詳細 カートに追加するボタン処理
// ------------------------------------------------
document.addEventListener('click', function(e) {

  const btn = e.target.closest('.add-to-cart-button');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  const variantInput = form.querySelector('[name="id"]');
  if (!variantInput) return;

  const variantId = variantInput.value;

  const stock = window.variantInventory?.[variantId] ?? 0;

  // ★ ローカルカウント（ここがキモ）
  window._cartLocalCount = window._cartLocalCount || {};

  const current = window._cartLocalCount[variantId] || 0;

  // すでに上限なら止める
  if (current >= stock) {
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '在庫上限です';
    return;
  }

  // ★ クリック時点で即カウント増やす
  window._cartLocalCount[variantId] = current + 1;

  // ★ 1回目の時点で上限到達なら即ロック
  if (window._cartLocalCount[variantId] >= stock) {
    setTimeout(() => {
      btn.disabled = true;

      btn.textContent = '在庫上限です';

      btn.style.fontSize = '20px';
      btn.style.fontWeight = '600';
      btn.style.fontFamily = '"Noto Sans JP", sans-serif';
      btn.style.textAlign = 'center';
      btn.style.letterSpacing = '0';
      btn.style.lineHeight = '1.46';

    }, 300);
  }

});